// extracted by mini-css-extract-plugin
export default {"chevron":"item-module__chevron___dcrz8V","icon":"item-module__icon___dHNT88"};